import ExportService from "@/services/ExportService";

export default {
  state: {
    csvUrlShops: null,
    csvUrlFlux: null,
    csvUrlStats: null,
    csvUrlMarketing: null,
    total: null,
    totalRequest: null
  },
  mutations: {
    SET_CSV_URL_SHOPS(state, csvUrlAdmin) {
      state.csvUrlAdmin = csvUrlAdmin
    },
    SET_CSV_URL_FLUX(state, csvUrlAdmin) {
      state.csvUrlAdmin = csvUrlAdmin
    },
    SET_CSV_URL_STATS(state, csvUrlAdmin) {
      state.csvUrlAdmin = csvUrlAdmin
    },
    SET_CSV_URL_MARKETING(state, csvUrlMarketing) {
      state.csvUrlMarketing = csvUrlMarketing
    }
  },
  actions: {
    /**
     * Fetch shops export
     *
     * @param commit
     * @param model
     * @returns {*}
     */
    csvShopsExport({ commit }, model) {
      return ExportService.csvShopsExport(model)
        .then(response => {
          commit('SET_CSV_URL_SHOPS', response.data)

          return Promise.resolve(response.data)
        })
        .catch(error => {
        })
    },
    /**
     * Fetch flux export
     *
     * @param commit
     * @param model
     * @returns {*}
     */
    csvFluxExport({ commit }, model) {
      return ExportService.csvFluxExport(model)
        .then(response => {
          commit('SET_CSV_URL_FLUX', response.data)

          return Promise.resolve(response.data)
        })
        .catch(error => {
        })
    },
    /**
     * Fetch stats export
     *
     * @param commit
     * @param model
     * @returns {*}
     */
    csvStatsExport({ commit }, model) {
      return ExportService.csvStatsExport(model)
        .then(response => {
          commit('SET_CSV_URL_STATS', response.data)

          return Promise.resolve(response.data)
        })
        .catch(error => {
        })
    },
    /**
     * Call API for generate and download XLSX FILE
     *
     * @param commit
     * @param model
     * @returns {*}
     */
    exportMarketing({ commit }, model) {
      return ExportService.postShopsExportMarketing(model)
        .then(response => {
          commit('SET_CSV_URL_MARKETING', response.data)

          return Promise.resolve(response.data)
        })
        .catch(error => {
        })
    },
  },
}
